export const calculateProgress = (uploading: number[]) =>
  uploading.length ? Math.floor(uploading.reduce((pv, u) => pv + u, 0) / uploading.length) : 0;
